import axios from 'axios';
import { getToken } from '../pages/Auth/authSCG';

function getHeaders() {
  const headers = { Authorization: '' };
  const token = getToken();

  if (token) {
    headers.Authorization = `Bearer ${token}`;
    return headers;
  }
}

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

client.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...getHeaders() };
  return config;
});

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let errorMessage;
    if (error.response) {
      // Backend responded with a status code
      if (error.response.data?.statusCode) {
        errorMessage = `${error.response.data.message}|${error.response.data.statusCode}`;
      } else if (error.response.data?.error?.message) {
        errorMessage = `${error.response.data.error.message}|${error.response.status}`;
      } else {
        errorMessage = `Server error. Please try again later|${
          error.response.status || 500
        }`;
      }
    } else if (error.request) {
      // Request made, no response received
      errorMessage = 'Cannot get the response from the server|503';
    } else {
      // Something else happened
      errorMessage = 'Unexpected error occurred|0';
    }
    return Promise.reject(errorMessage);
  }
);

export default client;
